import styled from 'styled-components';
import { CHROME_INSET_PX } from './chrome.constants';

export const RailSlot = styled.div`
  position: absolute;
  top: 50%;
  left: ${CHROME_INSET_PX}px;
  translate: 0 -50%;
  z-index: 2;
  pointer-events: auto;
`;
